import React, { useState } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CForm,
  CFormLabel,
  CFormInput,
  CFormSelect,
  CButton,
  CRow,
  CCol,
} from "@coreui/react";

const StoreFilter = ({ open, onClose, onApply, initialFilters }) => {
  const [filters, setFilters] = useState(
    initialFilters || {
      name: "",
      type: "",
      smd: "",
      status: "",
      daysSinceVisit: "",
    }
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onApply(filters);
  };

  const handleReset = () => {
    setFilters({
      name: "",
      type: "",
      smd: "",
      status: "",
      daysSinceVisit: "",
    });
    onApply({}); // Apply empty filters to reset
  };

  return (
    <CModal visible={open} onClose={onClose} size="lg">
      <CModalHeader>
        <CModalTitle>Filter Toko</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol md={6}>
              <CFormLabel>Nama Toko</CFormLabel>
              <CFormInput
                type="text"
                name="name"
                value={filters.name}
                onChange={handleInputChange}
                placeholder="Cari berdasarkan nama"
              />
            </CCol>
            <CCol md={6}>
              <CFormLabel>Tipe Toko</CFormLabel>
              <CFormSelect name="type" value={filters.type} onChange={handleInputChange}>
                <option value="">Semua Tipe</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="D">D</option>
              </CFormSelect>
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md={6}>
              <CFormLabel>SMD</CFormLabel>
              <CFormInput
                type="text"
                name="smd"
                value={filters.smd}
                onChange={handleInputChange}
                placeholder="Cari berdasarkan SMD"
              />
            </CCol>
            {/* <CCol md={6}>
              <CFormLabel>Status</CFormLabel>
              <CFormSelect name="status" value={filters.status} onChange={handleInputChange}>
                <option value="">Semua Status</option>
                <option value="active">Aktif</option>
                <option value="inactive">Nonaktif</option>
                <option value="maintenance">Maintenance</option>
              </CFormSelect>
            </CCol> */}
          </CRow>

          <CRow className="mb-3">
            <CCol md={6}>
              <CFormLabel>Hari Sejak Kunjungan Terakhir</CFormLabel>
              <CFormSelect name="daysSinceVisit" value={filters.daysSinceVisit} onChange={handleInputChange}>
                <option value="">Semua</option>
                <option value="7">&lt; 7 hari</option>
                <option value="14">7-14 hari</option>
                <option value="30">15-30 hari</option>
                <option value="31">&gt; 30 hari</option>
              </CFormSelect>
            </CCol>
          </CRow>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={handleReset}>
          Reset
        </CButton>
        <CButton color="primary" onClick={handleSubmit}>
          Terapkan Filter
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default StoreFilter;
